// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import application from './application';
import AccountRequestController from './admin/account_request_controller';
import AddressBookController from './address_book_controller';
import AddressBlockController from './address_block_controller';
import AdjustmentsController from './adjustments_controller';
import AdminGarmentItemsController from './admin/garment_items_controller';
import AdminUsersController from './admin/users_controller';
import AlertsController from './alerts_controller';
import AlertsFilterController from './alerts_filter_controller';
import ArtworkSelectionController from './artwork_selection_controller';
import ClipboardController from './clipboard_controller';
import ColorRunController from './color_run_controller';
import ColorWayController from './color_way_controller';
import DigitalPrintTypeController from './digital_print_type_controller';
import DynamicSelectController from './dynamic_select_controller';
import FrameSrcResetController from './frame_src_reset_controller';
import InternationalAddressController from './international_address_controller';
import LineItemArtworkController from './line_item_artwork_controller';
import LineItemPersonalizationController from './line_item_personalization_controller';
import OrderController from './order_controller';
import OrderDisciplineFilterController from './order_discipline_filter_controller';
import OrderStatusController from './order_status_controller';
import PersonalizationListController from './personalization_list_controller';
import PersonalizationSelectionController from './personalization_selection_controller';
import ProduceableTypeController from './produceable_type_controller';
import ProductPriceController from './product_price_controller';
import QuickQuoteController from './quick_quote_controller';
import RepeatArtController from './repeat_art_controller';
import ResourcesVizController from './resources_viz_controller';
import TomSelectController from './tom_select_controller';
import TurboModalController from './turbo_modal_controller';
import VisibilityController from './visibility_controller';

application.register('account-request', AccountRequestController);
application.register('address-block', AddressBlockController);
application.register('address-book', AddressBookController);
application.register('adjustments', AdjustmentsController);
application.register('admin-users', AdminUsersController);
application.register('alerts', AlertsController);
application.register('alerts-filter', AlertsFilterController);
application.register('artwork-selection', ArtworkSelectionController);
application.register('clipboard', ClipboardController);
application.register('color-run', ColorRunController);
application.register('color-way', ColorWayController);
application.register('digital-print-type', DigitalPrintTypeController);
application.register('dynamic-select', DynamicSelectController);
application.register('frame-src-reset', FrameSrcResetController);
application.register('garment-items', AdminGarmentItemsController);
application.register('international-address', InternationalAddressController);
application.register('line-item-artwork', LineItemArtworkController);
application.register(
  'line-item-personalization',
  LineItemPersonalizationController
);
application.register('order', OrderController);
application.register(
  'order-discipline-filter',
  OrderDisciplineFilterController
);
application.register('order-status', OrderStatusController);
application.register('personalization-list', PersonalizationListController);
application.register(
  'personalization-selection',
  PersonalizationSelectionController
);
application.register('produceable-type', ProduceableTypeController);
application.register('product-price', ProductPriceController);
application.register('quick-quote', QuickQuoteController);
application.register('repeat-art', RepeatArtController);
application.register('resources-viz', ResourcesVizController);
application.register('tom-select', TomSelectController);
application.register('turbo-modal', TurboModalController);
application.register('visibility', VisibilityController);
